// components/widgets/primitives/section-strip.js
// ═══════════════════════════════════════════════════════════
// SECTION STRIP — hairline divider with inline section label.
// Renders:  ─── label (count) ───────────
// Use to separate logical sections inside a widget body.
// ═══════════════════════════════════════════════════════════

export default function SectionStrip({ label, count, children, className = '' }) {
  return (
    <div className={`ws-prim-section ${className}`}>
      <div className="ws-prim-section-divider">
        <span className="ws-prim-section-divider-line" aria-hidden />
        <span className="ws-prim-section-label">
          {label}
          {typeof count === 'number' && (
            <span className="ws-prim-section-count"> ({count})</span>
          )}
        </span>
        <span className="ws-prim-section-divider-line ws-prim-section-divider-grow" aria-hidden />
      </div>
      <div className="ws-prim-section-content">{children}</div>
    </div>
  );
}
